import React from "react";
import ReactDOM from "react-dom/client";
import { HelmetProvider } from "react-helmet-async";
import { PrimeReactProvider } from "primereact/api";
import { BasketProvider } from "./context/BasketContext";
import "primeicons/primeicons.css";
import "./index.css";
import App from "./App";
import "primereact/resources/themes/lara-light-cyan/theme.css";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
    <React.StrictMode>
        <HelmetProvider>
            <PrimeReactProvider>
                <BasketProvider>
                    <App />
                </BasketProvider>
            </PrimeReactProvider>
        </HelmetProvider>
    </React.StrictMode>
);
